import React, { useCallback } from 'react';

import { breakpoints as breakpointMap } from '../components/theme';

export type breakpointStateType = {
  xs: boolean;
  sm: boolean;
  md: boolean;
  lg: boolean;
  xl: boolean;
  xxl: boolean;
};

const listeners = new Set<() => void>();
const onResizeCaller = () => listeners.forEach(l => l());
window.addEventListener('resize', onResizeCaller);

const useBreakpoint = () => {
  const [state, setState] = React.useState<breakpointStateType>({
    xs: true,
    sm: true,
    md: true,
    lg: true,
    xl: true,
    xxl: true,
  });

  const onResize = useCallback(() => {
    setState(prevState => {
      const { innerWidth: width } = window;
      let hasChanged = false;

      const newState = { ...prevState };

      Object.keys(breakpointMap).forEach((key: keyof typeof breakpointMap) => {
        const point = breakpointMap[key];
        const result = width >= point;
        if (result !== prevState[key]) hasChanged = true;
        newState[key] = result;
      });

      // To prevent unnecessary re-renders:
      if (hasChanged) {
        return newState;
      }
      return prevState;
    });
  }, []);

  React.useEffect(() => {
    listeners.add(onResize);
    onResize();
    return () => {
      listeners.delete(onResize);
    };
  }, []);

  return state;
};

export default useBreakpoint;
